<template>
  <div class="wapper">

    <el-page-header @back="goBack"
                    content="发票详情"
                    class="header">
    </el-page-header>
    <div class="content-wapper">
      <div class="opertion-wapper">
        <el-button size="small"
                   v-if="info.state==1"
                   type="primary"
                   @click="submitDialog">确认提交</el-button>
      </div>
      <span class="title">申请基础信息</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>申请编号</label>
            <span>{{info.invoiceApplyCode}}</span>
          </div>
          <div>
            <label>开票状态</label>
            <span>{{info.stateName}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>开票数量</label>
            <span>{{info.countApplyInvoice}}张</span>
          </div>
          <div>
            <label>申请人</label>
            <span>{{info.creatorName}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>所属部门</label>
            <span>{{info.ownerDepartmentName}}</span>
          </div>
          <div>
            <label>申请时间</label>
            <span>{{info.gmtCreate}}</span>
          </div>
        </li>

      </ul>
    </div>
    <div class="content-wapper">
      <span class="title">申请订单信息</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>客户名称</label>
            <span>{{info.customerName}}</span>
          </div>
          <div>
            <label>本次开票总额</label>
            <span>{{info.totalApplyInvoice}}元</span>
          </div>
        </li>
      </ul>

      <el-table :data="info.reOrderList">
        <el-table-column prop="orderNo"
                         label="订单编号">
        </el-table-column>
        <el-table-column prop="orderTypeName"
                         label="订单类型">
        </el-table-column>
        <el-table-column prop="invoiceApplyAmount"
                         label="本次开票金额">
        </el-table-column>
        <el-table-column label="操作"
                         width="150">
          <template slot-scope="scope">
            <span style="color:blue;cursor:pointer;"
                  @click="detail(scope.row)">订单详情</span>
          </template>
        </el-table-column>

      </el-table>

    </div>
    <div class="content-wapper">
      <span class="title">客户发票信息</span>
      <ul class="info-wapper">
        <li>
          <div>
            <label>发票抬头</label>
            <span>{{info.invoiceTitleInfo.invoiceTitle}}</span>
          </div>
          <div>
            <label>纳税人识别号</label>
            <span>{{info.invoiceTitleInfo.taxpayerCode}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>公司注册电话</label>
            <span>{{info.invoiceTitleInfo.companyPhone}}</span>
          </div>
          <div>
            <label>公司注册地址</label>
            <span>{{info.invoiceTitleInfo.companyAddress}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>开户行名称</label>
            <span>{{info.invoiceTitleInfo.companyBankName}}</span>
          </div>
          <div>
            <label>开户行账号</label>
            <span>{{info.invoiceTitleInfo.companyBankAccount}}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="content-wapper"
         style="width:100%;">
      <span class="title">开票信息</span>
      <ul class="info-wapper"
          style="background-color:rgb(240 240 240);padding:10px;margin-bottom:30px;"
          v-for="item in info.invoiceList"
          :key="item.companyId">
        <li>
          <div>
            <label>发票类型</label>
            <span>{{item.invoiceTypeName}}</span>
          </div>
          <div>
            <label>开票公司</label>
            <span>{{item.companyName}}</span>
          </div>
        </li>
        <li>
          <div>
            <label>合约开票总额</label>
            <span>{{$numberUtils.divide(item.totalInvoice,100)}}元</span>
          </div>
          <div>
            <label>单张开具最大额</label>
            <span>{{$numberUtils.divide(item.maxAmountEach,100)}}元</span>
          </div>
        </li>
        <li v-if="item.invoiceType==3">
          <div>
            <label>接收人手机号</label>
            <span>{{item.receiverPhone}}</span>
          </div>
          <div>
            <label>接收人邮箱</label>
            <span>{{item.receiverEmail}}</span>
          </div>
        </li>

        <div v-for="ite in item.contentBaseList"
             :key="ite.invoiceApplyId"
             style="width:100%;">
          <div class="table-top"> 开票信息编号： {{ite.invoiceInfoCode}}</div>
          <el-table :data="ite.contentList">
            <el-table-column prop="invoiceContentId"
                             label="内容编号">

              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="invoiceContent"
                             label="发票内容">
            </el-table-column>
            <el-table-column prop="count"
                             label="数量">
            </el-table-column>
            <el-table-column prop="price"
                             label="单价">
            </el-table-column>
            <el-table-column label="开票金额">

              <template slot-scope="scope">
                {{$numberUtils.divide(scope.row.invoiceAmount,100)}}

              </template>
            </el-table-column>
          </el-table>
        </div>
      </ul>
      <br>
    </div>
    <div class="content-wapper"
         style="width:100%;"
         v-if="info.state!=1">
      <span class="title">发票审核信息</span>
      <examine ref="examine"
               :businessCode="info.id"
               :templateId="info.templateId"></examine>
    </div>
    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               width="30%">
      <span>提交后发票信息不可编辑修改，是否确认提交？</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, toRefs, onMounted } from '@vue/composition-api'
import _request from '@/utils/request.js'
import _tax from '@/service/tax-service'
import examine from '@/views/common/examine'
export default {
  components: {
    examine
  },
  setup (props, { root }) {


    const data = reactive({
      dialogVisible: false,
      info: {
        invoiceApplyCode: null,
        invoiceTitleInfo: {}
      },
      tableData: [],
      query: {
        id: root.$route.query.id
      }
    })
    //详情数据
    const getDetail = () => {
      _tax.invoiceApplyGetDetail(
        data.query,
        response => {
          // 请求成功
          data.info = response
          data.info.totalApplyInvoice = root.$numberUtils.divide(Number(data.info.totalApplyInvoice), 100)

          if (data.info.reOrderList) {
            data.info.reOrderList.forEach(item => {
              item.invoiceApplyAmount = root.$numberUtils.divide(Number(item.invoiceApplyAmount), 100)
            })
          }

        }, response => {
          this.$notify({
            message: response,
            type: 'warning'
          })
        })
    }
    //订单详情
    const detail = (row) => {
      if (row.orderType == 3) {
        location.href = _request.getCrmBaseUrl(`/integral-order-detail?orderNo=${row.orderNo}`)
      } else {
        if (row.orderType == 2) {
          location.href = _request.getCrmBaseUrl(`/recharge-order-detail?id=${row.orderNo}`)
        }
        if (row.orderType != 3 && row.storedOrderType == 1) {
          location.href = _request.getCrmBaseUrl(`/stored-order-detail?id=${row.orderNo}`)
        } else if (row.orderType != 3 && row.storedOrderType == 2) {
          location.href = _request.getCrmBaseUrl(`/stored-order-custom-detail?id=${row.orderNo}`)
        }
      }

    }
    //弹窗
    const submitDialog = () => {
      data.dialogVisible = true
    }
    //提交
    const submit = () => {
      _tax.invoiceApplyGetDetailSubmit(data.query, response => {
        data.dialogVisible = false
        root.$router.push({
          path: '/invoice-manage-list'
        })
      }, response => {
        root.$notify({
          message: response,
          type: 'warning'
        })
      })
    }


    onMounted(() => {
      getDetail()
    })

    return {
      ...toRefs(data), detail, submitDialog, submit
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }

  }

}
</script>

<style scoped>
.wapper {
  padding: 15px;
}
.header {
  margin-bottom: 15px;
}
.content-wapper {
  border: 1px solid #d6dbe5;
  border-radius: 3px;
  padding: 30px;
  padding-top: 15px;
  background: #fff;
}
.title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}
.info-wapper li {
  margin: 15px 0;
}
.info-wapper li div {
  display: inline-block;
  width: 400px;
  position: relative;
}
.info-wapper .special {
  width: 800px;
}
.info-wapper span {
  margin-left: 130px;
  display: inline-block;
  vertical-align: top;
}
.info-wapper label {
  color: #909399;
  display: inline-block;
  width: 100px;
  text-align: right;
  position: absolute;
  top: 0;
}
.textarea {
  display: inline-block;
  width: 500px;
}
.images-wapper {
  border-top: 1px dashed #909399;
  margin-top: 30px;
}
.info-wapper .el-image {
  width: 210px;
  height: 100px;
  border-radius: 6px;
  margin-left: 15px;
}
.table-wapper {
  margin-left: 130px;
  width: 550px;
}
.table-wapper label {
  padding: 10px 0;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  border: 1px solid #d6dbe5;
  border-bottom: none;
}
.table-wapper table {
  border: 1px solid #d6dbe5;
  width: 100%;
}
.table-wapper td {
  padding: 10px;
  border-bottom: 1px solid #d6dbe5;
  border-right: 1px solid #d6dbe5;
}
.table-wapper tr:first-child td {
  font-weight: bold;
  background: #f9f9f9;
}
.table-top {
  width: 100%;
  font-weight: bold;
  border: 1px solid #cdd0d6;
  border-bottom: none;
  height: 50px;
  background: #fff;
  padding-top: 15px;
  padding-left: 10px;
}
</style>